import React, { useState } from 'react'
import { 
    Header,
    Button,
    Paragraph,
    MortgageRegulationContacts, 
    ErrorMark
} from "../../../components/RegularComponents";
import TopNavigationBar from "../../TopNavigationBar";
import * as CONST from "../../../app/constants";
import * as UTILS from '../../../app/utils';
import { useDispatch, useSelector } from 'react-redux';
import { push } from 'connected-react-router';
import { setMortgageProperty } from '../../../redux/slice/primaryAgencyApplicationSlice';


export const ContentAwareness = (props) => {

    const { isModal = false, onEditSave = () => {} } = props;
    const isMRACompliance = useSelector(state => state?.primaryAgencyApplication?.application?.businessLicenceData?.isMRACompliance);
    const [selectedOption,setSelectedOption] = useState(isMRACompliance === true ? "yes" : (isMRACompliance === false ? "no" : "")); 
    const dispatch = useDispatch();
    
    const handleContinue = () => {
        
        if(selectedOption === "no") {
            return
        }

        if(isModal) {
            onEditSave()
        } else {
            let nextUrl = CONST.ROUTE_PATH.MRA_RENEWAL_CONFIRM_AIR_SUBMISSION;

            dispatch(
                push({
                    pathname: UTILS.replaceUrlParams(
                    `${CONST.ROUTE_PATH.MRA_APP}${nextUrl}`,
                    CONST.APPLICATION_TYPE_MORTGAGE_BROKERAGE_LICENCE,
                    CONST.APPLICATION_MODE_RENEW
                    )
                })
            );
        }
    }

    const onYesClick = () => {
        setSelectedOption("yes")
        dispatch(
            setMortgageProperty({
                key: "isMRACompliance",
                value: true
            })
        );
    }

    const onNoClick = () => {
        setSelectedOption("no")
        dispatch(
            setMortgageProperty({
                key: "isMRACompliance",
                value: false
            })
        );
    }

    return (
        <div className={!isModal ? "container" : ""}>
        
        {!isModal && <TopNavigationBar {...props} />}
        
        <div className="row">
                {!isModal && 
                <div className="col-xs-12 col-lg-11">
                    <Header
                        id="mra-renewal-confirm-pb-header"
                        header="Mortgage Brokerage Licence Renewal"
                    />
                </div>}
                <div className="col-xs-12 col-lg-11 topMarginMedium">
                    <Paragraph
                        id="mra-renewal-compliance-text-1"
                        text={[
                            `It is your responsibility to be in compliance with <a href="${CONST.MRA_REGULATION_ACT_DOCUMENT_LINK}" target="blank">the Mortgage Regulation Act (MRA)</a> and <a href="${CONST.MRA_REGULATION_JUSTICE_LINK}" target="blank"> regulations</a>.`,
                        ]}
                    />
                    <Paragraph
                        id="mra-renewal-compliance-text-2"
                        style={{fontWeight: "bold", fontSize: "1.2em"}}
                        text={[
                            `Are you in compliance with the Mortgage Regulation Act?`,
                        ]}
                    />
                </div>
            </div>
        
        <div className={"row"}>
            <div className={"col-8"}>
                <fieldset className={"ns-fieldset" + (selectedOption === "no" ? " ns-fieldset-message-error" : "")}>
                    <div className={"ns-radios ns-radios--small"}>
                        <div 
                            key={"mra-renewal-compliance-yes"} 
                            className="ns-radios__item" style={{marginBottom: "15px"}}
                            onClick={onYesClick}
                        >
                            <input
                                className="ns-radios__input"
                                key={"mra-renewal-compliance-yes-input"}
                                type={"radio"}
                                value={"yes"}
                                checked={selectedOption === "yes"}
                                onClick={onYesClick}
                                id={
                                    "mra-renewal-compliacne-yes-input"
                                }
                                name={"mra-renewal-compliance-group"}
                            />
                            <label
                                key={"mra-yes-label"}
                                id={
                                "mra-renewal-compliance-yes-label"
                                }
                                className="ns-radios__label"
                                htmlFor={
                                "mra-renewal-compliance-yes-input"
                                }
                            >
                                <span className="ns-label-span">
                                    Yes
                                </span>
                            </label>
                        </div>
                        <div 
                            key={"mra-renewal-compliance-no"} 
                            className="ns-radios__item"
                            onClick={onNoClick}
                        >
                            <input
                                className="ns-radios__input"
                                key={"mra-renewal-compliance-no-input"}
                                type={"radio"}
                                value={"no"}
                                checked={selectedOption === "no"}
                                onClick={onNoClick}
                                id={
                                    "mra-renewal-compliacne-no-input"
                                }
                                name={"mra-renewal-compliance-group"}
                            />
                            <label
                                key={"mra-no-label"}
                                id={
                                "mra-renewal-compliance-no-label"
                                }
                                className="ns-radios__label"
                                htmlFor={
                                "mra-renewal-compliance-no-input"
                                }
                            >
                                <span className="ns-label-span">
                                    No
                                </span>
                            </label>
                        </div>
                        {selectedOption === "no" && 
                            <MortgageRegulationContacts message="You must be in compliance to continue the renewal.
                             Please contact Business Licensing to discuss your application." 
                            />
                        }
                    </div>
                </fieldset>
            </div>
        </div>

        <div className="row">
            <div className="col-lg-8">
                <div className={"col-lg-3" + (selectedOption === "no") ? " has-error" : ""}>
                    <Button
                    className="btn-lg btn-default"
                    buttonType={"regular_primary"}
                    text={!isModal ? "Continue" : "Save and close"}
                    onClick={handleContinue}
                    />
                    {(selectedOption === "no") && ErrorMark()}
                </div>
            </div>
        </div>
    </div>
    )
}